/* Bazan PDP — Origin Stats carousel: dot indicator + drag-scroll + arrow buttons. */
(function () {
  'use strict';

  function initSection(root) {
    if (!root || root._bzInit) return;
    root._bzInit = true;
    var track = root.querySelector('[data-bz-origin-track]');
    if (!track) return;

    var isDown = false, startX = 0, sl = 0, moved = false;
    track.addEventListener('mousedown', function (e) {
      isDown = true; moved = false;
      startX = e.pageX - track.offsetLeft; sl = track.scrollLeft;
      track.classList.add('is-dragging');
      e.preventDefault();
    });
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    ['mouseleave','mouseup'].forEach(function (evt) {
      track.addEventListener(evt, function () {
        isDown = false;
        track.classList.remove('is-dragging');
      });
    });
    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      moved = true;
      track.scrollLeft = sl - ((e.pageX - track.offsetLeft) - startX) * 1.2;
    });

    var slides = Array.prototype.slice.call(track.querySelectorAll('.bz-pdp-origin__slide'));
    var dotsWrap = root.querySelector('[data-bz-origin-dots]');
    var prevBtn = root.querySelector('[data-bz-origin-prev]');
    var nextBtn = root.querySelector('[data-bz-origin-next]');

    function stepSize() {
      var first = slides[0];
      if (!first) return track.clientWidth;
      var second = slides[1];
      var gap = second ? (second.offsetLeft - (first.offsetLeft + first.offsetWidth)) : 0;
      return first.offsetWidth + gap;
    }
    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      var max = track.scrollWidth - track.clientWidth - 1;
      prevBtn.classList.toggle('is-hidden', track.scrollLeft <= 0);
      nextBtn.classList.toggle('is-hidden', track.scrollLeft >= max);
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -stepSize(), behavior: 'smooth' }); });
    if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left: stepSize(), behavior: 'smooth' }); });

    var dots = [];
    if (dotsWrap && slides.length > 1) {
      dotsWrap.innerHTML = '';
      slides.forEach(function (s, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'bz-pdp-origin__dot' + (i === 0 ? ' is-active' : '');
        d.addEventListener('click', function () { s.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); });
        dotsWrap.appendChild(d);
        dots.push(d);
      });
    }
    function update() {
      var trackRect = track.getBoundingClientRect();
      var center = trackRect.left + trackRect.width / 2;
      var best = 0, bestDist = Infinity;
      slides.forEach(function (s, i) {
        var r = s.getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - center);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      if (dots.length) dots.forEach(function (d, i) { d.classList.toggle('is-active', i === best); });
      updateArrows();
    }
    track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function boot() { document.querySelectorAll('[data-bz-pdp-origin]').forEach(initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector('[data-bz-pdp-origin]');
    if (r) initSection(r);
  });
})();
